class VimeoPlayer {
    constructor(video_id){
        //console.log('Player:Vimeo');
        this.video_id = video_id;
        this.options = {
            title:false,
            loop:false
        };
        this.events = {
            mute:false,
            play:false,
            stop:false
        };
        this.is_ready = false;
    }

    ready (){
        this.is_ready = true;
        Object.keys(this.events).map((event) => {
            //console.log('Event:', event, this.events[event]);
            if(this.events[event] === true){
                this[event]();
            }
        });
    }

    showTitle(status){
        this.options.title = status === false ? 0 : 1;
        return this;
    }

    mute(){
        if(!this.is_ready){
            this.events.mute = true;
            return this;
        }
        //console.log('Vimeo:mute');
        this.player.setVolume(0);
        return this;
    }

    play(){
        if(!this.is_ready){
            this.events.play = true;
            return this;
        }
        //console.log('Vimeo:play');
        this.player.play().then(function(){
            //console.log('Vimeo isplay ok');
        })
        .catch(function(error) {
            //console.log('Vimeo error:', error);
            switch (error.name) {
                case 'PasswordError':
                    break;
                case 'PrivacyError':
                    break;
                default:
                    break;
            }
        });
        return this;
    }

    stop(){
        if(!this.is_ready){
            this.events.play = true;
            return this;
        }
        //console.log('Vimeo:stop');
        this.player.unload();
        document.getElementById(this.video_id).childNodes[0].remove();
        return this;
    }

    source(source){
        let content = document.getElementById(this.video_id);
        let iframe = document.createElement('iframe');
        iframe.src = source;
        iframe.setAttribute('width', '100%');
        iframe.setAttribute('height', '100%');
        iframe.setAttribute('frameborder', 0);
        iframe.setAttribute('webkitallowfullscreen', '');
        iframe.setAttribute('mozallowfullscreen', '');
        iframe.setAttribute('allowfullscreen', '');
        
        content.appendChild(iframe);
        content.style.width = '100%';
        content.style.height = '100%';

        this.player = new Vimeo.Player(iframe, this.options);
        this.player.ready().then(() => {
            this.ready();
          });
        return this;
    }
}

export default VimeoPlayer;